import React from "react";
import { Badge, BadgeType, BadgeTypeName } from "../../../types/badge";
import { Form, Input, Modal, Select } from "antd";

export interface BadgeCreateFormProps {
  open: boolean;
  onCreate: (record: Badge) => void;
  onCancel: () => void;
}

export const BadgeCreateForm = (props: BadgeCreateFormProps) => {
  const [form] = Form.useForm();

  const badgeTypeOptions = [
    { value: BadgeType.RECOMMENDED, label: BadgeTypeName[BadgeType.RECOMMENDED] },
    { value: BadgeType.DEPRECATED, label: BadgeTypeName[BadgeType.DEPRECATED] },
    { value: BadgeType.UNSTABLE, label: BadgeTypeName[BadgeType.UNSTABLE] },
    { value: BadgeType.NEW, label: BadgeTypeName[BadgeType.NEW] },
  ];

  return (
    <Modal
      open={props.open}
      title="Add Badge"
      okText="Add"
      cancelText="Cancel"
      onCancel={() => {
        form.resetFields();
        props.onCancel();
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            props.onCreate(values);
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
    >
      <Form form={form} layout="vertical" name="badge_form">
        <Form.Item
          name="type"
          label="Badge Type"
          rules={[{ required: true, message: "Please select the badge type!" }]}
        >
          <Select options={badgeTypeOptions} placeholder="Select badge type" />
        </Form.Item>
        <Form.Item name="message" label="Message">
          <Input placeholder="Optional message for the badge" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
